import axios from "../../../../apis/Api";
import history, { logout } from "../../../../history";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { GET_MONTHLY_DELIVERYMAN_UNIQUE_SHOPS_REPORT } from "../../../../Types";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";

export const GetMonthlyDeliverymanUniqueShopsReport =
  (postedData) => async (dispatch) => {
    dispatch(showLoading());
    await axios
      .post(
        `api/DeliverymanReports/GetMonthlyDeliverymanUniqueShopsReport`,
        postedData
      )
      .then(({ data }) => {
        dispatch({
          type: GET_MONTHLY_DELIVERYMAN_UNIQUE_SHOPS_REPORT,
          payload: data.response,
        });
        dispatch(hideLoading());
      })
      .catch(function (error) {
        dispatch(hideLoading());
        if (error.response) {
          if (error.response.status === 401) {
            logout();
            history.push("/login");
            history.go("/login");
          } else if (
            error.response.status === 400 &&
            error.response.data.errors
          ) {
            let errorMessage = "";
            var errors = error.response.data.errors;
            var keys = Object.keys(errors);
            for (let j = 0; j < keys.length; j++) {
              errorMessage += errors[keys[j]] + " , \n";
            }
            toast.error(errorMessage);
          } else if (error.response.data)
            toast.error(
              error.response.data.Message
                ? error.response.data.Message
                : error.response.data.message
            );
          else {
            toast.error("Error while processing the request");
          }
        } else toast.error("Error while processing the request");
      });
  };

export const exportReport = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(
      `api/DeliverymanReports/GetMonthlyDeliverymanUniqueShopsReport`,
      postedData
    )
    .then(({ data }) => {
      const outputFilename = `Deliveryman_Unique_Shops_Report_${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      // Only include selected columns
      const selectedColumns = [
        "distcenter",
        "deliverymanName",
        "uniqueShopsInvoices",
        "uniqueShopstransacted",
        "noOfTansactions",
        "percentageOfActiveShops",
        "invoicesAmount",
        "m2DAmount",
        "m2DPercentage",
      ];

      const exportToCSV = (csvData, jobNumber, fileName) => {
        // Map data to only selected columns
        const filteredData = csvData.map((row) => {
          const filteredRow = {};
          selectedColumns.forEach((col) => {
            filteredRow[col] = row[col] ?? ""; // default to empty string if null
          });
          return filteredRow;
        });

        const ws = XLSX.utils.json_to_sheet(filteredData);
        if (ws) {
          var range = XLSX.utils.decode_range(ws["!ref"]);
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            if (!ws[address]) continue;
            if (ws[address].v == "deliverymanId") continue;
            ws[address].v =
              ws[address].v == "distcenter"
                ? "Distribution Center"
                : ws[address].v == "deliverymanName"
                ? "Deliveryman Name"
                : ws[address].v == "uniqueShopsInvoices"
                ? "Unique Shops Invoices"
                : ws[address].v == "uniqueShopstransacted"
                ? "Unique Shops Transacted"
                : ws[address].v == "noOfTansactions"
                ? "No of Transactions"
                : ws[address].v == "percentageOfActiveShops"
                ? "% of Active Shop (Against Invoice)"
                : ws[address].v == "invoicesAmount"
                ? "Invoices Amount"
                : ws[address].v == "m2DAmount"
                ? "M2D Amount"
                : ws[address].v == "m2DPercentage"
                ? "M2D %"
                : ws[address].v;
          }
        }
        // var sheetName = `Job_Number_${jobNumber}`
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };
      exportToCSV(data.response?.data, "", outputFilename);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
